export default __webpack_public_path__ + "static/media/i-interior - bcr.4fbfa676.svg";